module.exports = __webpack_public_path__ + "img/contribute_3.3e2f2f53.png";